import SHAREBOX_S32_REOPEN_STEPS from './s32';

const SHAREBOX_M28_REOPEN_STEPS = SHAREBOX_S32_REOPEN_STEPS;

export default SHAREBOX_M28_REOPEN_STEPS;
